import { render } from "./Accordion.vue?vue&type=template&id=8ccd6e70"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=8ccd6e70&lang=css"
script.render = render

export default script